/**
 * Marken-Slider: horizontales Scrollen mit Prev/Next.
 */
(() => {
  class TkBrandSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-tk-bslide-track]');
      this.prevBtn = this.querySelector('[data-tk-bslide-prev]');
      this.nextBtn = this.querySelector('[data-tk-bslide-next]');
      if (!this.track) return;

      this.onScroll = () => this.updateButtons();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevBtn?.addEventListener('click', () => this.scrollByDir(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByDir(1));

      this.ro = new ResizeObserver(() => this.updateButtons());
      this.ro.observe(this.track);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.ro?.disconnect();
    }

    slideStep() {
      const slide = this.track.querySelector('.tk-bslide__slide, .tk-tops__slide');
      if (!slide) return this.track.clientWidth * 0.75;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    scrollByDir(dir) {
      this.track.scrollBy({ left: dir * this.slideStep(), behavior: 'smooth' });
    }

    updateButtons() {
      const el = this.track;
      const max = el.scrollWidth - el.clientWidth - 2;
      const atStart = el.scrollLeft <= 2;
      const atEnd = el.scrollLeft >= max;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
      this.classList.toggle('is-no-nav', max <= 0);
      this.classList.toggle('tk-bslide--no-nav', max <= 0);
    }
  }

  if (!customElements.get('tk-brand-slider')) {
    customElements.define('tk-brand-slider', TkBrandSlider);
  }
})();
